export default "__VITE_ASSET__BXMfUp3l__"